// Function to set the cart timestamp
function setCartTimestamp() {
    const timestamp = new Date().getTime(); // current time in milliseconds
    localStorage.setItem('cartTimestamp', timestamp);
}

// Set the timestamp when an item is added to the cart
document.addEventListener('DOMContentLoaded', () => {
    const cartButton = document.querySelector('.product-form__submit'); // Update selector based on your theme

    if (cartButton) {
        cartButton.addEventListener('click', () => {
            setCartTimestamp();
            console.log('run');
        });
    }
});

// Function to clear the cart
async function clearCart() {
    try {
        await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        localStorage.removeItem('cartTimestamp'); // Remove timestamp after clearing the cart
    } catch (error) {
        console.error('Error clearing cart:', error);
    }
}

// Check if 48hours have passed
function checkCartExpiration() {
    const cartTimestamp = localStorage.getItem('cartTimestamp');
    if (cartTimestamp) {
        const currentTime = new Date().getTime();
        const timeElapsed = currentTime - parseInt(cartTimestamp, 10);

        const fortyEightHours = 48 * 60 * 60 * 1000;
        if (timeElapsed >= fortyEightHours) {
            clearCart();
        }
    }
}

// Run the check on page load
document.addEventListener('DOMContentLoaded', checkCartExpiration);
